/*
Gireesh 04/04/2023 2699762545 Table colmn and API Changes
Akhila 04/07/2023 2699762545 Added delete functionality and delete reason dialog box
Gireesh 06/04/2023 2699762545 Added filter options and payload changes
Ravi 04/10/2023 2699762545 Removed arrow up down from Account Number
Sohel 04/11/2023 2699762545 Fixed Table refresh issue
Guru Prasad 04/11/2023 2699762545 Fixed alignments
Akhila 04/13/2023 2699762545 Added warning popup message
Ravi 06/30/2023 2699762545 fixed search button functionality
*/

import React, {createRef, useState, useContext, useEffect} from 'react';
// import MaterialTable from "material-table";
import {tableIcons} from '../../../components/TableIcons/index';
import {makeStyles, Button, TextField, Typography} from '@material-ui/core';
import {useDispatch, useSelector} from 'react-redux';
import {httpPaginationPost} from '../../../util/Rest';
import {ThemeContext} from '../../../themes/ThemeProvider';
import DialogBox from '../../../components/DialogBox';
import {tablePageRows, defaultRows} from '../../../constants/ReusableTablePagination';
import ExecuteForm from './ExecuteForm';
import {Link} from 'react-router-dom';
import moment from 'moment';
import GuiTable from '../../../components/FormComponents/GuiTable';
import {ErrorSnackbar, SuccessSnackbar} from '../../../components/CustomSnackBar';
import {LETTER_MAINTENANCE} from '../../../constants/ReusableRoleAccess';

import {
  resetLetters,
  resetErrorWarningMsg,
} from '../../../redux/reducers/LetterBatches';
import DeleteLetterRequest from '../../../util/DeleteTableRecordPopup';
import LetterDeleteRequest from './LetterDeleteRequest';
import {Form, Formik} from 'formik';
import {positiveNumberOnly} from '../../../util/Currency';
import ExecuteWarningPopup from './ExecuteWarningPopup';

// import { tablePageRows, defaultRows } from "../../../../constants/ReusableTablePagination";
// import { TablePagination } from "@material-ui/core";

// import {
//   resetLetters,
//   resetStatus,
//   letterRequestExecuteBatch,
//   fetchGroupCodes,
//   fetchRequestedLetters,
//   fetchLetterHistory,
// } from "../../../../redux/reducers/LetterBatches";
const useStyles = makeStyles((theme) => ({
  cardStyles: {
    whiteSpace: 'nowrap',
    padding: 10,
    marginTop: 20,
    marginBottom: 10,
    boxShadow:
      '0px 1px 0px rgb(0 0 0 / 10%), 0px 0px 1px rgb(0 0 0 / 10%), 0px 1px 2px rgb(0 0 0 / 10%)',
    borderRadius: '8px',
    backgroundColor: '#ffffff',
  },

  toolTip: {
    zIndex: '9 !important',
  },
  batchNumber: {
    color: '#2e6ae1',
    cursor: 'pointer',
    textDecoration: 'underline',
  },
  disabledBatchNumber: {
    color: '#676767',
    textDecoration: 'underline',
  },
  link: {
    color: '#320469 !important',
    borderBottom: '1px solid #000099',
    fontSize: '14px !important',
    fontFamily: 'articulat-cf, sans-serif !important',
  },
}));
const LettersRequested = ({setValue}) => {
  const classes1 = useStyles();
  const dispatch = useDispatch();
  const [searchData, setSearchData] = useState('');
  const [submit, setSubmit] = useState(false);
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const [isDelete, setIsDelete] = useState(false);
  const [isConfirmDelete, setIsConfirmDelete] = useState(false);
  const [deleteData, setDeleteData] = useState([]);
  const {
    successMsg,
    isLoading,
    lettersDataStatus,
    errorMsg,
    executeBatchStatus,
    warningError,
  } = useSelector(({letterBatches}) => letterBatches);
  const [arrayLast, setArrayLast] = useState(false);
  const tableRef = createRef();
  const {roleData} = useSelector(({role}) => role);
  const LetterRequestAccess = roleData?.window?.[LETTER_MAINTENANCE]?.['LR'];

  const {successMsg: requestSuccess, errorMsg: requestErrorMsg} = useSelector(
    ({letterHistory}) => letterHistory,
  );
  const handleIsDeleteClose = () => {
    setIsDelete(false);
  };
  const handleConfirmSubmit = () => {
    setIsConfirmDelete(false);
    setIsDelete(true);
  };

  const handleIsConfirmDeleteClose = () => {
    setIsConfirmDelete(false);
  };

  const [warningOpen, setWarningOpen] = useState(false);
  useEffect(() => {
    if (warningError !== null) {
      setWarningOpen(true);
    }
  }, [warningError]);
  const handleValidationClose = () => {
    setWarningOpen(false);
    // setValidationError(false);
    // setStatus(true);
    dispatch(resetErrorWarningMsg());
    // setProcessorGroupCode("");
  };
  const columns = [
    {
      title: 'Account Number',
      field: 'accountNumber',
      maxWidth: 150,
      render: (rowData) => {
        return rowData && rowData.accountNumber ? (
          <Link
            // onClick={() =>
            //   sessionStorage.setItem("batchName", batchName ? batchName : batch ? batch : null)
            // }
            to={{
              pathname: `/account-summary`,
              state: {
                accountNumber: rowData?.accountNumber ? rowData.accountNumber : '',
                // batchName: batchName ? batchName : batch ? batch : null,
                // accountData: accountData?.length > 0 ? accountData : [],
              },
            }}
            className={classes1.link}
          >
            {rowData.accountNumber}
          </Link>
        ) : null;
      },
    },
    {
      title: 'Code',
      field: 'letterCode',
      maxWidth: 130,
    },
    {
      title: 'Description',
      field: 'letterDescription',
      headerStyle: {textAlign: 'left', fontSize: 16},
      render: (rowData) => (
        <>
          <div
            style={{
              maxWidth: 500,
              textAlign: 'justify',
              whiteSpace: 'normal',
              wordWrap: 'break-word',
            }}
          >
            {rowData?.letterDescription}
          </div>
        </>
      ),
    },
    {
      title: 'Group Code',
      field: 'letterGroupCode',
      type: 'string',
    },
    {
      title: 'Requested Date',
      field: 'createdDate',
      render: (rowData) =>
        rowData.createdDate ? moment(rowData.createdDate).format('MM/DD/YYYY') : '',
    },
    {
      title: 'User',
      field: 'createdBy',
    },
  ];

  const [open, setOpen] = useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  const onClear = () => {
    const data = {
      code: '',
      description: '',
      accountNumber: '',
      groupCode: '',
    };
    setSearchData(data);
  };
  // useEffect(() => {
  //   dispatch(fetchRequestedLetters());
  // }, []);
  useEffect(() => {
    if (lettersDataStatus === 200 || executeBatchStatus === 200) {
      tableRef.current.onQueryChange();
      dispatch(resetLetters());
    }
  }, [lettersDataStatus, executeBatchStatus]);
  useEffect(() => {
    if (tableRef.current && submit) {
      Object.keys(searchData).length > 0 ? tableRef.current.onQueryChange() : '';
    }
  }, [submit]);

  // const searchApiData =
  //   requestedLetters.length > 0
  //     ? requestedLetters.map((item, i) => ({
  //       ...item,
  //       id: i,
  //     }))
  //     : [];
  const initialValues = {
    code: '',
    description: '',
    accountNumber: '',
    groupCode: '',
  };
  const handleSubmit = (values) => {
    setSearchData(values);
    setSubmit(true);
  };

  return (
    <>
      <h2 className="search-title">Letter Request Search</h2>
      <Formik
        onSubmit={(values) => handleSubmit(values)}
        initialValues={initialValues}
        enableReinitialize
      >
        {(props) => {
          const {values, handleChange, handleBlur, resetForm, touched} = props;

          return (
            <div>
              <Form autoComplete="off">
                <div className="form-row standard-field-textfields new-standard-textfields">
                  <div className={`col-sm-6 col-xs-6 col-md-4 col-lg-3 col-xl-3 form-group`}>
                    <TextField
                      margin="dense"
                      variant="outlined"
                      className={` ${classes.labelName}`}
                      type="text"
                      placeholder={`Enter Account Number`}
                      label="Account Number"
                      name="accountNumber"
                      value={values?.accountNumber}
                      InputProps={{
                        inputComponent: positiveNumberOnly,
                      }}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      fullWidth
                      touched={touched.accountNumber}
                    />
                  </div>
                  <div className={`col-sm-6 col-xs-6 col-md-4 col-lg-3 col-xl-3 form-group`}>
                    <TextField
                      margin="dense"
                      variant="outlined"
                      className={` ${classes.labelName}`}
                      placeholder={`Enter Code`}
                      label="Code"
                      name="code"
                      value={values?.code}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      fullWidth
                      touched={touched.code}
                    />
                  </div>
                  <div className={`col-sm-6 col-xs-6 col-md-4 col-lg-3 col-xl-3 form-group`}>
                    <TextField
                      margin="dense"
                      variant="outlined"
                      className={` ${classes.labelName}`}
                      name="description"
                      placeholder={`Enter Description`}
                      label="Description"
                      value={values.description}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      fullWidth
                    />
                  </div>
                  <div className={`col-sm-6 col-xs-6 col-md-4 col-lg-3 col-xl-3 form-group`}>
                    <TextField
                      margin="dense"
                      variant="outlined"
                      className={` ${classes.labelName}`}
                      placeholder={`Enter Group Code`}
                      label="Group Code"
                      name="groupCode"
                      value={values?.groupCode}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      fullWidth
                      touched={touched.groupCode}
                    />
                  </div>
                  <div className="col-md-4 col-lg-12 mb-3">
                    <div className="d-flex justify-content-md-start justify-content-lg-center">
                      <Button
                        variant="outlined"
                        className={`mr-1 reset-btn`}
                        // type="submit"
                        onClick={() => {
                          resetForm();
                          onClear();
                        }}
                      >
                        Reset
                      </Button>
                      <Button type="submit" variant="outlined" className={`ml-1 search-btn`}>
                        Search
                      </Button>
                    </div>
                  </div>
                </div>
              </Form>
            </div>
          );
        }}
      </Formik>
      <DialogBox title={'Execute Letter Batch'} open={open} dialogClose={handleClose} maxWidth="md">
        <ExecuteForm handleClose={handleClose} setValue={setValue} open={open} />
      </DialogBox>
      <div
        className={`custom-table custom-toolbar-icons custom-actions-icon global-field-table new-standard-textfields tablescroll-block`}
      >
        <GuiTable
          icons={tableIcons}
          title=""
          columns={columns}
          isLoading={isLoading}
          tableRef={tableRef}
          // data={searchApiData ? searchApiData : []}
          data={(query) =>
            new Promise((resolve) => {
              const url = `letter/request/find/all/requestedletter`;
              const bodyObj = {
                accountNumber: searchData?.accountNumber ? searchData?.accountNumber : '',
                letterCode: searchData?.code ? searchData?.code : '',
                letterDescription: searchData?.description ? searchData?.description : '',
                letterGroupCode: searchData?.groupCode ? searchData?.groupCode : '',
                limit: query.pageSize ? query.pageSize : null,
                search: '',
                orderBy: query.orderBy && query.orderBy.field ? query.orderBy.field : '',
                orderDirection: query.orderDirection,
                page: submit ?
                  1 :
                  arrayLast && query.page >= 1 ?
                    query.page :
                    arrayLast ?
                      (query.page <= 1 && query.page + 1) || query.page - 1 :
                      query.page + 1,
              };
              httpPaginationPost(url, bodyObj)
                .then((response) => {
                  if (response?.status === 200) {
                    const data = response.data.response.resultObjets;
                    resolve({
                      data: data.length > 0 ? data : [],
                      page: response.data.response.page - 1,
                      totalCount: response.data.response.count,
                    });
                    setArrayLast(data.length === 1);
                    setSubmit(false);
                  } else {
                    resolve({
                      data: [],
                      page: 0,
                      totalCount: 5,
                    });
                    dispatch({
                      type: 'FETCH_ERROR',
                      payload: response && response.message ? response.message : null,
                    });
                  }
                })
                .catch((response) => {
                  resolve({
                    data: [],
                    page: 0,
                    totalCount: 5,
                  });
                  dispatch({
                    type: 'FETCH_ERROR',
                    payload: response && response.message ? response.message : null,
                  });
                });
            })
          }
          options={{
            toolbar: true,
            search: false,
            debounceInterval: 500,
            pageSize: defaultRows,
            pageSizeOptions: tablePageRows,
            emptyRowsWhenPaging: false,
            headerStyle: {
              fontWeight: 'bold',
            },
            selection: true,
            // selectionProps: (rowData) => ({
            //   disabled: !LetterRequestAccess?.delete,
            // }),
          }}
          actions={[
            {
              icon: () => (
                <>
                  <Button
                    type="button"
                    variant="outlined"
                    disabled={!LetterRequestAccess?.delete}
                    className={`search-btn ml-2 ${classes.buttonRoot}`}
                  >
                    <Typography variant="inherit">Delete Letters</Typography>
                  </Button>
                </>
              ),
              disabled: !LetterRequestAccess?.delete,
              tooltip: 'Delete Selected Letters',
              onClick: (event, rowData) => {
                setIsConfirmDelete(true);
                setDeleteData(rowData);
              },
            },
            {
              icon: () => (
                <div>
                  <Button
                    type="button"
                    disabled={!LetterRequestAccess?.add && !LetterRequestAccess?.edit}
                    variant="outlined"
                    className={`search-btn`}
                  >
                    Execute Letter Batch
                  </Button>
                </div>
              ),
              disabled: !LetterRequestAccess?.add && !LetterRequestAccess?.edit,
              isFreeAction: true,
              onClick: () => {
                setOpen(true);
              },
            },
          ]}
        />
        <DialogBox
          open={isDelete}
          title="Please share us reason for deleting Letter Request"
          maxWidth={'md'}
          dialogClose={handleIsDeleteClose}
        >
          <LetterDeleteRequest
            isDelete={isDelete}
            setIsDelete={setIsDelete}
            deleteData={deleteData}
            tableRef={tableRef}
          />
        </DialogBox>
      </div>
      <DialogBox
        open={warningOpen}
        dialogClose={handleValidationClose}
        title="Warning !"
        maxWidth="sm"
      >
        <ExecuteWarningPopup
          handleValidationClose={handleValidationClose}
          warningError={warningError}
        />
      </DialogBox>
      <DeleteLetterRequest
        open={isConfirmDelete}
        dialogClose={handleIsConfirmDeleteClose}
        title="Delete Letter Request"
        value={`Are you sure you want to delete these ${deleteData?.length} letters requests ?`}
        handleSubmit={handleConfirmSubmit}
      />
      {/* {successMsg && <SuccessSnackbar successMsg={successMsg} />} */}
      {(errorMsg || requestErrorMsg) && <ErrorSnackbar errorMsg={errorMsg || requestErrorMsg} />}
      {(successMsg || requestSuccess) && (
        <SuccessSnackbar successMsg={successMsg || requestSuccess} />
      )}
    </>
  );
};

export default LettersRequested;
